var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1111 6.4C19.3469 6.4 19.573 6.48429 19.7397 6.63431C19.9064 6.78434 20 6.98783 20 7.2C20 7.41217 19.9064 7.61566 19.7397 7.76569C19.573 7.91571 19.3469 8 19.1111 8H18.2222L18.2196 8.0568L17.3902 18.5136C17.3583 18.9173 17.1576 19.2951 16.8285 19.5709C16.4995 19.8467 16.0665 20 15.6169 20H8.38222C7.93257 20 7.49962 19.8467 7.17056 19.5709C6.84151 19.2951 6.64081 18.9173 6.60889 18.5136L5.77956 8.0576C5.77821 8.03843 5.77761 8.01921 5.77778 8H4.88889C4.65314 8 4.42705 7.91571 4.26035 7.76569C4.09365 7.61566 4 7.41217 4 7.2C4 6.98783 4.09365 6.78434 4.26035 6.63431C4.42705 6.48429 4.65314 6.4 4.88889 6.4H19.1111ZM16.4418 8H7.55822L8.38311 18.4H15.6169L16.4418 8ZM13.7778 4C14.0135 4 14.2396 4.08429 14.4063 4.23431C14.573 4.38434 14.6667 4.58783 14.6667 4.8C14.6667 5.01217 14.573 5.21566 14.4063 5.36569C14.2396 5.51571 14.0135 5.6 13.7778 5.6H10.2222C9.98647 5.6 9.76038 5.51571 9.59368 5.36569C9.42698 5.21566 9.33333 5.01217 9.33333 4.8C9.33333 4.58783 9.42698 4.38434 9.59368 4.23431C9.76038 4.08429 9.98647 4 10.2222 4H13.7778Z",
    fill: "#0A186E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_delete.bb9c77c2da950f020dfed6f3108dee3f.svg";